import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { DeviceActivityResponse } from '@/types/apps/device-activity.type';

interface DeviceActivityState {
    data: DeviceActivityResponse;
}

const initialState: DeviceActivityState = {
    data: {} as DeviceActivityResponse,
};

export const deviceActivitySlice = createSlice({
    name: 'deviceActivity',
    initialState,
    reducers: {
        setDeviceActivityAction: (
            state,
            action: PayloadAction<DeviceActivityResponse>
        ) => {
            state.data = action.payload;
        },
    },
});

export const { setDeviceActivityAction: setDeviceDetailAction } =
    deviceActivitySlice.actions;

export default deviceActivitySlice.reducer;
